export default "__VITE_ASSET__DstgWNMk__"